import React from 'react';
import { Header, Footer } from '../Common';
import { connect } from 'react-redux';
import { buyerAskEstimation } from '../../Action/buyerEstimation';
import { withRouter } from 'react-router-dom';
import Buyer from '../../Models/Buyer';
import Products from '../../Models/Products';
import { Link } from 'react-router-dom';
class RequestConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            budget: '',
            title: '',
            image: '',
            contents: '',
        }
        console.log(this.props.location.state)
        this.getBudgetRange();
        this.getTitle();
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.setState({ contents: this.props.location.state.content })
    }
    getTitle() {
        Products.getProductsDetails(this.props.location.state.id).then(res => {
            console.log(res.data.product)
            res.data.product.map(res =>
                this.setState({ title: res.title, image: res.img })
            )
        })
    }
    // getDetails(id) {
    //     Products.getProductsDetails(id).then(res => {
    //         this.setState({ productDetails: res.data.product })
    //     })
    // }
    getBudgetRange() {
        Buyer.getBudgetRange(this.props.location.state.budgets).then(res => {
            this.setState({ budget: res.data.payload.budget_range })
        })
    }
    handleSubmit(e) {
        document.getElementById("res_entry").disabled = true;
        e.preventDefault();
        if (this.props.location.state.product_id == '' || this.props.location.state.product_id == null) {
            alert("データを取得できませんでした！ 後で試してください.")
            return;
        } else if (this.props.location.state.buyer_id == '' || this.props.location.state.buyer_id == null) {
            alert("データを取得できませんでした！ 後で試してください")
            return;
        } else if (this.props.location.state.title == '' || this.props.location.state.title == null) {
            alert("タイトルを入れてください.")
            return;
        } else if (this.props.location.state.date == '' || this.props.location.state.date == null) {
            alert("日付を入れてください.")
            return;
        } else if (this.props.location.state.content == '' || this.props.location.state.content == null) {
            alert("サービス内容を入れてください.")
            return;
        } else {
            let data = {
                product_id: this.props.location.state.product_id,
                buyer_id: this.props.location.state.buyer_id,
                title: this.props.location.state.title,
                application_date: this.props.location.state.date,
                content: this.props.location.state.content,
                budget: this.props.location.state.budgets
            }
            this.props.buyerAskEstimation(data, this.props.history);
        }
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="adjust-to-page" style={{ backgroundColor: "white", border: "none" }}>
                        <div className="">
                            <div className="request_confirm_align desktop_margin" style={{marginTop:'0px'}}>

                                <div style={{ color: "black", paddingTop: "0%" ,paddingBottom:'0%',fontSize:'20px',textAlign:'left'}}>
                                    <span className="standard_heading">
                                        <b>見積り・カスタマイズの相談内容を確認する</b>
                                    </span>
                                </div>
                                <div className=" card " style={{ padding: "3%" }}>
                                    <div className="row">
                                        <div className="col-md-3 text-center" style={{ marginTop: '15px' }}>
                                            <img alt="" src={this.state.image} height="180" width='180' style={{ objectFit: 'cover' }} />
                                        </div>
                                        <div className="col-md-7" style={{ marginTop: '15px', marginLeft: '15px' }}>
                                            <div className="request_title">
                                                <h4> {this.props.location.state.title}</h4>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 ">
                                                    <div className="request_service_name" style={{ margin: '0px' }}>
                                                        サービス名
                                                    </div>
                                                </div>
                                                <div className="col-md-9">
                                                    {this.state.title}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3">
                                                    <div className="request_service_name" style={{ margin: '0px' }} >
                                                        提案期限
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    {this.props.location.state.date}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3">
                                                    <div className="request_service_name" style={{ margin: '0px' }}>
                                                        予算目安
                                                    </div>
                                                </div>
                                                <div className="col-md-3">
                                                    {this.state.budget}
                                                </div>
                                            </div>
                                            <div className=" mt-3 card-text">
                                                {this.state.contents.split('\n').map(function (item, key) {
                                                    return (
                                                        <span key={key}>
                                                            {item}
                                                            <br />
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="request_confirm_button"style={{margin:'20px'}}>
                                    <div className="row">
                                        <div className="col-6 left_button" >
                                            <Link to={{
                                                pathname: `/buyer-ask-estimate/${this.props.location.state.id}`,
                                                state: {
                                                    id: this.props.location.state.id,
                                                    buyer_id: this.props.location.state.buyer_id,
                                                    title: this.props.location.state.title,
                                                    application_date: this.props.location.state.date,
                                                    content: this.props.location.state.content,
                                                    budget: this.props.location.state.budgets
                                                }
                                            }}>
                                                <button type="submit" className="request_confirm_edit " style={{width:'100%'}}><h5>修正する</h5></button>
                                            </Link>
                                        </div>
                                        {/* <div className="col-md-2">&nbsp;</div> */}
                                        <div className="col-6 right_button">
                                            <button type="submit" id="res_entry" style={{ backgroundColor: "#7ea9e6", border: "#6290d1",width:'100%' }} className="request_confirm_edit"  onClick={this.handleSubmit.bind(this)}>相談を送る</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />

                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="col-md-12 tr_blank_medium mt-4 pt-2"></div>
                    <div className="adjust-to-page" style={{ backgroundColor: "white", border: "none" }}>
                        <div className="">
                            <div className="request_confirm_align desktop_margin">

                                <div className="request_confirm_text small_no_pads" style={{ color: "black", padding: "3%" }}>
                                    <span className="standard_heading">
                                        <b>見積り・カスタマイズの相談内容を確認する</b>
                                    </span>
                                </div>
                                <div className=" card small_no_pads" style={{ padding: "3%" }}>
                                    <div className="row">
                                        <div className="col-md-4 text-center" >
                                            <img alt="" src={this.state.image} height="180" width='180' style={{ objectFit: 'cover' }} />
                                        </div>
                                        <div className="col-md-8" >
                                            <div className="request_title">
                                                <h4> {this.props.location.state.title}</h4>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3 align-self-start">
                                                    <div className="request_service_name" style={{ margin: '0px', paddingTop: '4px', textAlign: 'center' }}> サービス名 </div>
                                                </div>
                                                <div className="col-md-9">
                                                    {this.state.title}
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-3">
                                                    <div className="request_service_name" style={{ margin: '0px', paddingTop: '4px', textAlign: 'center' }}> 提案期限 </div>
                                                </div>
                                                <div className="col-md-3 ">
                                                    {this.props.location.state.date}
                                                </div>
                                                <div className="col-md-3">
                                                    <div className="request_service_name" style={{ margin: '0px', paddingTop: '4px', textAlign: 'center' }}>予算目安 </div>
                                                </div>
                                                <div className="col-md-3 ">
                                                    {this.state.budget}
                                                </div>
                                            </div>
                                            <div className=" mt-3 card-text">
                                                {this.state.contents.split('\n').map(function (item, key) {
                                                    return (
                                                        <span key={key}>
                                                            {item}
                                                            <br />
                                                        </span>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="request_confirm_button">
                                    <div className="row">
                                        <div className="col-md-5 left_button">
                                            <Link to={{
                                                pathname: `/buyer-ask-estimate/${this.props.location.state.id}`,
                                                state: {
                                                    id: this.props.location.state.id,
                                                    buyer_id: this.props.location.state.buyer_id,
                                                    title: this.props.location.state.title,
                                                    application_date: this.props.location.state.date,
                                                    content: this.props.location.state.content,
                                                    budget: this.props.location.state.budgets
                                                }
                                            }}>
                                                <button type="submit" className="request_confirm_edit " ><h5>修正する</h5></button>
                                            </Link>
                                        </div>
                                        <div className="col-md-2">&nbsp;</div>
                                        <div className="col-md-5 right_button">
                                            <button type="submit" id="res_entry" style={{ backgroundColor: "#7ea9e6", border: "#6290d1" }} className="request_confirm_edit" onClick={this.handleSubmit.bind(this)}>相談を送る</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />

                </div>
            )
        }
    }
}
const mapStateToProps = (state) => ({
    buyerAskEstimation: state.buyerAskEstimation,
    errors: state.errors,
});
RequestConfirmation = connect(mapStateToProps, { buyerAskEstimation })(withRouter(RequestConfirmation));
export { RequestConfirmation }